import React from 'react';
import './Auth.sass';
import conf from '../../conf';

const Auth = ({ match }) => {
  const { method } = match.params;
  console.log(conf);
  if (method === 'arcgis') {
    window.location.href = `${conf.E2E_API_URL}auth/arcgis`;
  }

  return <></>;
};

export default Auth;
